import { Action } from "@ngrx/store";
import { IContext } from "../../context/models/context";
import { DiaryEvent } from '../models/diary-event'

export const FILTER = '[Diary] Filter';
export const LOAD = '[Diary] Load';
export const LOAD_COMPLETE = '[Diary] Load Complete';
export const LOAD_ERROR = '[Diary] Load Error';
export const LOAD_UNDATED_EVENTS = '[Diary] Load Undated';


export class Filter implements Action {
  readonly type = FILTER;
  constructor(public widgetId: string, public searchText : string ) { }
}
export class Load implements Action {
  readonly type = LOAD;
  constructor(public context: IContext, public startDate: Date, public endDate: Date, public widgetId: number ) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: DiaryEvent[], public widgetId: string ) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any, public widgetId: string ) { }
}
export class LoadUndatedEvents implements Action {
  readonly type = LOAD_UNDATED_EVENTS;
  constructor(public context: IContext, public widgetId: string) { }
}

export type Actions =
  Filter |
  Load |
  LoadComplete |
  LoadError |
  LoadUndatedEvents
  ;
